import { render, staticRenderFns } from "./intranetBusinessMemberRoleItem.vue?vue&type=template&id=20f83d67&scoped=true"
import script from "./intranetBusinessMemberRoleItem.vue?vue&type=script&lang=js"
export * from "./intranetBusinessMemberRoleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f83d67",
  null
  
)

export default component.exports